import { Box, Container, Flex, Grid, GridItem, Show, useMediaQuery } from "@chakra-ui/react";
import { Step, Steps, useSteps } from "chakra-ui-steps";
import { ReactElement, useEffect, useState } from "react";
import { useParams, useNavigate as routerNavigate} from "react-router-dom";
import ProgramService from "services/programs/program-service";
import Layout from "../layouts";
import LoadingScreen from "components/loading-screen";
import CheckoutCustomerStep from "./checkout-customer";
import CheckoutPaymentMethodStep from "./checkout-payment-method";
import CheckoutCompletePaymentStep from "./checkout-complete-payment";
import OrderService from "services/orders/order-service";
import CheckoutVoucher from "./checkout-voucher";
import VoucherService from "../../services/vouchers/voucher-service";
import PixelUtil from "../../utils/pixel-utils";

const formInitialValue = {
    name: '',
    email: '',
    phone: '',
};

const CheckoutScene = (): ReactElement => {
    const [isLoading, setLoading] = useState<boolean>(true);
    const [program, setProgram] = useState<any>(null);
    const { programId }: any = useParams();
    const { nextStep, prevStep, reset, activeStep } = useSteps({
        initialStep: 0,
    });
    const [isMobile] = useMediaQuery("(max-width: 768px)");
    const [formValue, setFormValue] = useState<any>(formInitialValue);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<string>("BANKTRANSFER");
    const [order, setOrder] = useState<any>(null);
    const [voucher, setVoucher] = useState<any>({ isApplied: false, appliedVoucherCode: "", isValid: false, isPercentage: false, value: 0, totalAfterDiscount: 0, message: "", changeAble: true, isCanExpire: false, expiryDate: null });
    const navigate = routerNavigate();

    useEffect(() => {
        setLoading(true);
        ProgramService.GetProgram(programId).then((response: any) => {
            setProgram(response.result);

            if (window.location.search) {
                let searchParam = new URLSearchParams(window.location.search);
                var voucher = searchParam.get('voucher');

                if (voucher) {
                    handleClaimVoucher({ voucherCode: voucher });
                }

                var name = searchParam.get('name')?.trim();
                var email = searchParam.get('email')?.trim();
                var phone = searchParam.get('phone')?.trim();
                phone = phone?.replaceAll('+', '');
                if (phone?.substring(0, 2) == '62') {
                    phone = '0' + phone?.substring(2, phone.length);
                }
                setFormValue({
                    name: name,
                    email: email,
                    phone: phone
                });
            }
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    useEffect(() => {
        if (program) {
            document.title = program.fullName;
            PixelUtil.TrackViewProduct(program.code, program.name);
        }
    }, [program]);

    const handleSubmitCustomerInfo = async (formValue: any) => {
        //setLoading(true);
        setFormValue(formValue);
        if (window.location.search) {
            let searchParam = new URLSearchParams(window.location.search);
            var voucherCode = searchParam.get('voucher');

            if (voucherCode) {
                handleClaimVoucherByEmail({ voucherCode: voucherCode }, formValue.email);
            }
        }
        PixelUtil.TrackInitialCheckout(program.code, program.name);

        var paymentMethod = 20;// selectedPaymentMethod === "MIDTRANS" ? 20 : 10;
        await OrderService.Checkout(formValue.name, formValue.email, formValue.phone, programId, voucher.appliedVoucherCode, paymentMethod).then((response: any) => {
            setOrder(response.result);
            setVoucher({ ...voucher, changeAble: false });

            PixelUtil.TrackCheckedOut(program.code, program.name);
            navigate(`/pay/${response.result.invoiceNo}`);
            //nextStep();
        }).catch((error: any) => {
            console.log(error);
        }).finally(() => {
            setLoading(false);
        });
    };

    const handleSubmitPaymentMethod = () => {
        var paymentMethod = selectedPaymentMethod === "MIDTRANS" ? 20 : 10;
        return OrderService.Checkout(formValue.name, formValue.email, formValue.phone, programId, voucher.appliedVoucherCode, paymentMethod).then((response: any) => {
            setOrder(response.result);
            setVoucher({ ...voucher, changeAble: false });

            PixelUtil.TrackCheckedOut(program.code, program.name);
            nextStep();
        }).catch((error: any) => {
            console.log(error);
        });
    };

    const handleClaimVoucher = (value: any) => {
        return VoucherService.Check(value.voucherCode, formValue.email, programId).then((response: any) => {
            var voucherResponse = response.result;
            if (voucherResponse.isValid) {
                setVoucher({ isApplied: true, appliedVoucherCode: voucherResponse.voucherCode, isValid: true, isPercentage: voucherResponse.isPercentage, value: voucherResponse.voucherValue, totalAfterDiscount: voucherResponse.totalAfterDiscount, message: voucherResponse.remarks, changeAble: true, isCanExpire: voucherResponse.isCanExpire, expiryDate: voucherResponse.expiryDate });
            } else {
                setVoucher({ isApplied: true, appliedVoucherCode: voucherResponse.voucherCode, isValid: false, isPercentage: false, value: 0, totalAfterDiscount: 0, message: voucherResponse.remarks, changeAble: true, isCanExpire: false, expiryDate: null });
            }
        }).catch((error: any) => {
            console.log(error);
        });
    };

    const handleClaimVoucherByEmail = (value: any, email: string) => {
        return VoucherService.Check(value.voucherCode, email, programId).then((response: any) => {
            var voucherResponse = response.result;
            if (voucherResponse.isValid) {
                setVoucher({ isApplied: true, appliedVoucherCode: voucherResponse.voucherCode, isValid: true, isPercentage: voucherResponse.isPercentage, value: voucherResponse.voucherValue, totalAfterDiscount: voucherResponse.totalAfterDiscount, message: voucherResponse.remarks, changeAble: true, isCanExpire: voucherResponse.isCanExpire, expiryDate: voucherResponse.expiryDate });
            } else {
                setVoucher({ isApplied: true, appliedVoucherCode: voucherResponse.voucherCode, isValid: false, isPercentage: false, value: 0, totalAfterDiscount: 0, message: voucherResponse.remarks, changeAble: true, isCanExpire: false, expiryDate: null });
            }
        }).catch((error: any) => {
            console.log(error);
        });
    };

    if (isLoading)
        return <LoadingScreen />;

    return (
        <Layout>
            <Container maxW={'8xl'}>
                <Grid templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(3, 1fr)' }} gap={{ base: 0, md: 5 }} mt={4}>
                    <Show below={"md"}>
                        <GridItem bgColor={'blackAlpha.50'} rounded={'lg'}>
                            <CheckoutVoucher program={program} handleSubmition={handleClaimVoucher} voucher={voucher} />
                        </GridItem>
                    </Show>

                    <GridItem colSpan={2}>
                        <Box>
                            <Flex flexDir="column" width="100%">
                                <CheckoutCustomerStep handleSubmition={handleSubmitCustomerInfo} defaultFormValue={formValue} />
                                {/*<Steps colorScheme="teal" activeStep={activeStep} variant="circles-alt" orientation={isMobile ? 'vertical' : 'horizontal'} size={'sm'}>*/}

                                {/*    <Step label={"Step 1: Informasi Anda"} key={"Order"} description={"Lengkapi Informasi Anda"}>*/}
                                {/*        <CheckoutCustomerStep handleSubmition={handleSubmitCustomerInfo} defaultFormValue={formValue} />*/}
                                {/*    </Step>*/}

                                {/*    <Step label={"Step 2: Pembayaran"} key={"Payment"} description={"Selesaikan Pembayaran"}>*/}
                                {/*        <CheckoutPaymentMethodStep handleSubmit={handleSubmitPaymentMethod} selectedPaymentMethod={selectedPaymentMethod} setSelectedPaymentMethod={setSelectedPaymentMethod} />*/}
                                {/*    </Step>*/}

                                {/*    <Step label={"Step 3: Akses Program"} key={"Complete"} description={"Akses ke Program"}>*/}
                                {/*        <CheckoutCompletePaymentStep paymentMethod={selectedPaymentMethod} order={order} />*/}
                                {/*    </Step>*/}
                                {/*</Steps>*/}
                            </Flex>
                        </Box>
                    </GridItem>

                    <Show above={"md"}>
                        <GridItem bgColor={'blackAlpha.50'} rounded={'lg'}>
                            <CheckoutVoucher program={program} handleSubmition={handleClaimVoucher} voucher={voucher} />
                        </GridItem>
                    </Show>
                </Grid >
            </Container >
        </Layout >);
};

export default CheckoutScene;

function useNavigate() {
    throw new Error("Function not implemented.");
}
